import { useTranslation } from '../../../components/Translation';
import type { LabEvent } from '../../../constants/events/events';

const statusColors: Record<string, string> = {
  destacado: "bg-dorado-uady text-white",
  proximo: "bg-blue-500 text-white",
  pasado: "bg-gray-400 text-white",
};

export default function EventCard({ event, onClick }: { event: LabEvent; onClick: () => void }) {
  const { t } = useTranslation();

  const title = t(`eventos.${event.titleKey}`) !== `eventos.${event.titleKey}` ? t(`eventos.${event.titleKey}`) : event.titleText;
  const description = t(`eventos.${event.descriptionKey}`) !== `eventos.${event.descriptionKey}` ? t(`eventos.${event.descriptionKey}`) : event.descriptionText;

  const formattedDate = new Date(event.date).toLocaleDateString(
    t('eventos.locale') !== 'eventos.locale' ? t('eventos.locale') : 'es-MX',
    { year: 'numeric', month: 'short', day: 'numeric' }
  );

  return (
    <div
      onClick={onClick}
      className="group cursor-pointer rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 flex flex-col h-full border border-white/60"
      style={{
        background: "rgba(255,255,255,0.7)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        boxShadow: "0 4px 24px rgba(13,31,53,0.08), inset 0 1px 0 rgba(255,255,255,0.8)"
      }}
    >
      <div className="relative h-44 overflow-hidden">
        <img
          src={event.imageSrc}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className={`absolute top-3 left-3 text-micro font-bold px-3 py-1 rounded-full ${statusColors[event.status]}`}>
          {t(`eventos.status_${event.status}`)}
        </span>
      </div>

      <div className="p-5 flex flex-col flex-1">

        {event.categoryKey && (
          <span className="text-micro font-bold uppercase text-dorado-uady tracking-widest mb-2">
            {t(`eventos.${event.categoryKey}`)}</span>
        )}
        
        <h3 className="text-base font-bold text-azul-uady mb-2 leading-snug line-clamp-2">
          {title}
        </h3>
        <p className="text-mini text-gray-600 leading-relaxed line-clamp-3 flex-1 text-justify">
          {description}
        </p>
        <div className="flex items-center gap-2 text-micro text-gray-400 mt-3 pt-3 border-t border-gray-100">
          <span>📅</span>
          <span className="capitalize">{formattedDate}</span>
        </div>
      </div>
    </div>
  );
}
